export default __webpack_public_path__ + "static/media/home-icon.0609f39d.webp";